"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BOX_APP_OPENED = "mutation boxAppOpened($appId: ID!) {\n  boxAppOpened(appId: $appId)\n}";
exports.default = BOX_APP_OPENED;
//# sourceMappingURL=boxAppOpened.js.map